import React, { useEffect, useRef, useState } from "react";
import JsonSchemaForms from "../../../json_schema_forms";
import { generateObjectPath } from "../../../json_schema_forms/helpers";
import personal_information from "./personal_information.json";
import _, { cloneDeep, set } from "lodash";
import {
  mapDispatchToProps,
  mapStateToProps,
  setValueByRecursion,
  applyPersonalInfoConsentDateAccepted,
  applyConsentDateAccepted,
} from "../../../helpers";
import { connect } from "react-redux";
// import { el } from "date-fns/locale";
// import { copySchema, copyStateToRedux } from "../../../redux/actions/actions";
import { debouncedCheckDuplicateEmail } from "../../../components/checkDuplicateEmail";
import EmailMatchDialog from "../../../components/EmailMatchDialog";
import { useTranslation } from "react-i18next";

function PersonalInformation(props) {
  const { t } = useTranslation();
  const [state, setState] = useState(props.componentState);

  const [jsonSchema, setJsonSchema] = React.useState(
    _.cloneDeep(personal_information)
  );

  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    return () => {
      setJsonSchema(_.cloneDeep(personal_information));
      props.duplicateEmailCheck(false);
    };
  }, []);

  useEffect(() => {
    if (state?.ApplicantDetails === undefined) {
      setState({
        ...state,
        ApplicantDetails: {
          BorrowerDetails: {
            FirstName: localStorage.getItem("username").split(" ")[0],
            LastName: localStorage.getItem("username").split(" ")[
              localStorage.getItem("username").split(" ").length - 1
            ],
            Email: localStorage.getItem("user_email"),
          },
        },
      });
      props.copyStateToRedux({
        ...props.componentState,
        ApplicantDetails: {
          BorrowerDetails: {
            FirstName: localStorage.getItem("username").split(" ")[0],
            LastName: localStorage.getItem("username").split(" ")[
              localStorage.getItem("username").split(" ").length - 1
            ],
            Email: localStorage.getItem("user_email"),
          },
        },
      });
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(props.componentState)) {
      setState(props.componentState);
    }
  }, [props.componentState]);

  useEffect(() => {
    if (props.componentSchema?.personalInformation) {
      setJsonSchema(props.componentSchema["personalInformation"]);
    }
  }, [props.componentSchema]);

  const onLoadFunc = (updatedSchema) => {
    props.copySchema(updatedSchema, "personalInformation");
  };

  const changeHandler = (updatedState, updatedSchema, label, item) => {
    let AreYouApplyingForAJointCreditWithACoBorrower = _.get(updatedState, [
      "JointCredit",
      "AreYouApplyingForAJointCreditWithACoBorrower",
    ]);

    if (AreYouApplyingForAJointCreditWithACoBorrower === "No") {
      if (
        _.get(updatedState, [
          "Declarations",
          "ApplicantDeclarations",
          "CoBorrowerDeclarations",
        ])
      ) {
        delete _.get(updatedState, ["Declarations", "ApplicantDeclarations"])[
          "CoBorrowerDeclarations"
        ];
      }
      if (
        _.get(updatedState, [
          "Declarations",
          "ApplicantDemographicInformation",
          "CoBorrowerDemographicInformation",
        ])
      ) {
        delete _.get(updatedState, [
          "Declarations",
          "ApplicantDemographicInformation",
        ])["CoBorrowerDemographicInformation"];
      }
    }
    if (
      updatedState?.Address?.BorrowerAddress?.BorrowerCurrentAddress
        ?.Housing !== null &&
      updatedState?.Address?.BorrowerAddress?.BorrowerCurrentAddress
        ?.Housing === "Own"
    ) {
      let firstMrtgage = parseFloat(
        updatedState?.Address?.BorrowerAddress?.BorrowerCurrentAddress[
          "FirstMortgage(P&I)"
        ]
      );
      let secondMrtgage = parseFloat(
        updatedState?.Address?.BorrowerAddress?.BorrowerCurrentAddress[
          "SecondMortgage(P&I)"
        ]
      );
      let homeInsurance = parseFloat(
        updatedState?.Address?.BorrowerAddress?.BorrowerCurrentAddress
          .HomeInsurance
      );
      let floodInsurance = parseFloat(
        updatedState?.Address?.BorrowerAddress?.BorrowerCurrentAddress
          .FloodInsurance
      );
      let realEstTax = parseFloat(
        updatedState?.Address?.BorrowerAddress?.BorrowerCurrentAddress
          ?.RealEstateTaxes
      );
      let mrtgageInsu = parseFloat(
        updatedState?.Address?.BorrowerAddress?.BorrowerCurrentAddress
          ?.MortgageInsurance
      );
      let associationDues = parseFloat(
        updatedState?.Address?.BorrowerAddress?.BorrowerCurrentAddress
          ?.AssociationDues
      );
      let other = parseFloat(
        updatedState?.Address?.BorrowerAddress?.BorrowerCurrentAddress?.Other
      );

      updatedState["Address"]["BorrowerAddress"]["BorrowerCurrentAddress"][
        "Total"
      ] = Math.round(
        _.sum([
          firstMrtgage ? firstMrtgage : 0.0,
          secondMrtgage ? secondMrtgage : 0.0,
          homeInsurance ? homeInsurance : 0.0,
          floodInsurance ? floodInsurance : 0.0,
          realEstTax ? realEstTax : 0.0,
          mrtgageInsu ? mrtgageInsu : 0.0,
          associationDues ? associationDues : 0.0,
          other ? other : 0.0,
        ])
      );
    }
    if (/email/i.test(label)) {
      const bidentifier = localStorage.getItem("bidentifier");
      const checkfunc = ({ hasDuplicate }) => {
        props.duplicateEmailCheck(hasDuplicate);
        if (hasDuplicate) {
          setDialogOpen(true);
        }
      };
      debouncedCheckDuplicateEmail(
        updatedState,
        "personalInformation",
        bidentifier === "0" ? null : props?.applicantsData,
        checkfunc
      );
    }
    let stateWithConsentTimestamps = applyPersonalInfoConsentDateAccepted(
      props.componentState,
      updatedState
    );
    if (item?.type === "ConsentButtons" && item.path) {
      const statePath = generateObjectPath(item.path);
      const section = statePath[0];
      const field = statePath[statePath.length - 1];
      const consentValue = _.get(updatedState, statePath);
      stateWithConsentTimestamps = applyConsentDateAccepted(
        stateWithConsentTimestamps,
        section,
        field,
        consentValue
      );
    }
    props.copySchema(updatedSchema, "personalInformation");
    setState(stateWithConsentTimestamps);
    props.copyStateToRedux(stateWithConsentTimestamps);
  };

  /**Temp fix give For MI6-3273 */
  useEffect(() => {
    if (
      state?.JointCredit?.AreYouApplyingForAJointCreditWithACoBorrower === "No"
    ) {
      /**MI6-3283 */
      delete state?.Address?.CoBorrowerAddress?.PreviousAddress;
      if (state?.Address?.CoBorrowerAddress !== undefined) {
        state.Address.CoBorrowerAddress.PreviousAddress = [];
        jsonSchema.properties.Address.properties.CoBorrowerAddress.properties.PreviousAddress.length = 0;
        setJsonSchema(jsonSchema);
      }
      /**MI6-3283 */

      /*MI6-3294*/
      delete state?.EmploymentAndIncome?.CoBorrower;
      /*MI6-3294*/
    }
    /**MI6-3300 */
    if (
      state?.JointCredit?.AreYouApplyingForAJointCreditWithACoBorrower === "No"
    ) {
      let filterdAdditionalIncome = [];

      state?.EmploymentAndIncome?.additionalIncome?.map((each, index) => {
        if (each?.belongsTo === "CoBorrower") {
          delete state?.EmploymentAndIncome?.additionalIncome[index];
        } else {
          filterdAdditionalIncome.push({ ...each, belongsTo: undefined });
        }
      });

      if (state?.EmploymentAndIncome?.additionalIncome !== undefined) {
        delete state?.EmploymentAndIncome?.additionalIncome;
        state.EmploymentAndIncome.additionalIncome = filterdAdditionalIncome;
      }
    }
    if (
      state?.JointCredit?.AreYouApplyingForAJointCreditWithACoBorrower === "No"
    ) {
      let filterAssets = [];
      state?.ManualAssetsEntry?.Assets.filter((each, index) => {
        if (each?.belongsTo === "CoBorrower" || each?.belongsTo === "Both") {
          return delete state?.ManualAssetsEntry?.Assets[index];
        } else {
          filterAssets.push({ ...each, belongsTo: undefined });
        }
      });

      if (state?.ManualAssetsEntry?.Assets) {
        state.otherAssets = filterAssets;
        state.ManualAssetsEntry.Assets = filterAssets;
      }
      if (props?.componentSchema?.listOfAssets?.properties !== undefined) {
        props.componentSchema.listOfAssets.properties.ManualAssetsEntry.properties.Assets.length =
          filterAssets.length;
      }
      props.copySchema(props.componentSchema);
    }
    /**MI6-3300 */

    if (
      state?.JointCredit?.AreYouApplyingForAJointCreditWithACoBorrower === "No"
    ) {
      if (
        state?.ApplicantDetails?.CoBorrowerDetails?.MaritalStatus
          ?.IsThereAPersonWhoIsNotYourLegal?.IsThereAPersonWhoIsNotYourLegal !==
        "Yes"
      ) {
        delete state?.ApplicantDetails?.CoBorrowerDetails?.MaritalStatus
          ?.IsThereAPersonWhoIsNotYourLegal?.DomesticRelationshipType;
      }
    }

    // console.log(state, "before")
    setState(state);
    props.copyStateToRedux(state);
  }, [state?.JointCredit?.AreYouApplyingForAJointCreditWithACoBorrower]);

  // console.log(state, "after")
  // console.log(jsonSchema, "schema")
  // console.log(props.componentState, "reduxstate")

  function calculateBorrowerYears(
    borrowerCoborrowerCurrAddr,
    borrowerCoborrowerPrevAddr
  ) {
    if (!_.isEmpty(props.componentState)) {
      let currentYears = 0;
      let currentMonths = 0;
      if (borrowerCoborrowerCurrAddr) {
        currentYears = parseInt(borrowerCoborrowerCurrAddr.NumberOfYears) || 0;
        currentMonths = parseInt(borrowerCoborrowerCurrAddr.Months) || 0;
      }

      let prevYears = 0;
      let prevMonths = 0;
      if (borrowerCoborrowerPrevAddr?.length > 0) {
        const result = borrowerCoborrowerPrevAddr.reduce(
          (acc, prev) => {
            return {
              prevYears: acc.prevYears + (parseInt(prev.NumberOfYears) || 0),
              prevMonths: acc.prevMonths + (parseInt(prev.Months) || 0),
            };
          },
          { prevYears: 0, prevMonths: 0 }
        );

        prevYears = result.prevYears;
        prevMonths = result.prevMonths;
      }
      return (
        ((currentYears + prevYears) * 12 + currentMonths + prevMonths) / 12
      );
    }
  }

  useEffect(() => {
    if (!_.isEmpty(props.componentState)) {
      let prevAddButtons = document.getElementsByClassName(
        "Add Previous Address"
      );
      let borrowerCurrAdd = _.get(
        props.componentState,
        ["Address", "BorrowerAddress", "BorrowerCurrentAddress"],
        {}
      );
      let borrowerPrevAddresses = _.get(
        props.componentState,
        ["Address", "BorrowerAddress", "PreviousAddress"],
        {}
      );
      let totalBorrowerYears = calculateBorrowerYears(
        borrowerCurrAdd,
        borrowerPrevAddresses
      );
      if (prevAddButtons && totalBorrowerYears >= 2) {
        prevAddButtons[0]?.style.setProperty("display", "none", "important");
      } else {
        prevAddButtons[0]?.style.setProperty("display", "inline", "important");
      }
    }
  }, [_.get(props.componentState, ["Address", "BorrowerAddress"], {})]);

  useEffect(() => {
    if (
      props?.componentState?.JointCredit
        ?.AreYouApplyingForAJointCreditWithACoBorrower === "Yes"
    ) {
      let prevAddButtons = document.getElementsByClassName(
        "Add Previous Address"
      );
      let coBorrowerCurrAdd = _.get(
        props.componentState,
        ["Address", "CoBorrowerAddress", "CurrentAddress"],
        {}
      );
      let coBorrowerPrevAddresses = _.get(
        props.componentState,
        ["Address", "CoBorrowerAddress", "PreviousAddress"],
        {}
      );
      let totalCoBorrowerYears = calculateBorrowerYears(
        coBorrowerCurrAdd,
        coBorrowerPrevAddresses
      );
      if (prevAddButtons && totalCoBorrowerYears >= 2) {
        prevAddButtons[1]?.style.setProperty("display", "none", "important");
      } else {
        prevAddButtons[1]?.style.setProperty("display", "inline", "important");
      }
    }
  }, [_.get(props.componentState, ["Address", "CoBorrowerAddress"], {})]);
  // Function to handle the validation of the number of dependents for Borrower or CoBorrower
  const handleNumberOfDependentsError = (
    tempJsonSchema,
    role,
    numberOfDependentsCheck
  ) => {
    // Set error flag based on validation result (true if invalid, false if valid)
    const errorValue = numberOfDependentsCheck ? true : false;

    // Update the schema with the error flag using recursion
    return setValueByRecursion(
      tempJsonSchema,
      [
        "properties",
        "ApplicantDetails",
        "properties",
        role,
        "properties",
        "NumberOfDependents",
        "properties",
        "NumberOfDependents",
        "error",
      ],
      () => errorValue,
      []
    );
  };

  const handleAgesOfDependentsError = (
    tempJsonSchema,
    role
  ) => {
    delete props.errorsDictionary["AgesOfDependents"];
    return setValueByRecursion(
      tempJsonSchema,
      [
        "properties",
        "ApplicantDetails",
        "properties",
        role,
        "properties",
        "NumberOfDependents",
        "properties",
        "AgesOfDependents",
        "error",
      ],
      () => false,
      []
    );
  };

  // useEffect hook to handle updates when the number of dependents changes
  useEffect(() => {
    // Ensure we have the necessary schema to work with
    let tempJsonSchema = props.componentSchema?.personalInformation;

    // Proceed if schema is available and number of dependents is valid for Borrower and CoBorrower
    if (tempJsonSchema) {
      const borrowerNumberOfDependents =
        props.componentState?.ApplicantDetails?.BorrowerDetails
          ?.NumberOfDependents?.NumberOfDependents;
      const coBorrowerNumberOfDependents =
        props.componentState?.ApplicantDetails?.CoBorrowerDetails
          ?.NumberOfDependents?.NumberOfDependents;
      const borrNumberOfDependentsCheck =
        borrowerNumberOfDependents === "" ||
        borrowerNumberOfDependents < 0 ||
        borrowerNumberOfDependents > 10;
      const coborrNumberOfDependentsCheck =
        coBorrowerNumberOfDependents === "" ||
        coBorrowerNumberOfDependents < 0 ||
        coBorrowerNumberOfDependents > 10;

      // Validate Borrower's number of dependents and handle error if invalid
      if (borrNumberOfDependentsCheck) {
        tempJsonSchema = handleNumberOfDependentsError(
          tempJsonSchema,
          "BorrowerDetails",
          borrNumberOfDependentsCheck
        );
        if(borrowerNumberOfDependents === 0 || borrowerNumberOfDependents === ""){
          tempJsonSchema = handleAgesOfDependentsError(
            tempJsonSchema,
            "BorrowerDetails"
          )
        }
        props.copySchema(tempJsonSchema, "personalInformation");
      }

      // Validate CoBorrower's number of dependents and handle error if invalid
      if (coborrNumberOfDependentsCheck) {
        tempJsonSchema = handleNumberOfDependentsError(
          tempJsonSchema,
          "CoBorrowerDetails",
          coborrNumberOfDependentsCheck
        );
        if(coBorrowerNumberOfDependents === 0 || coBorrowerNumberOfDependents === ""){
          tempJsonSchema = handleAgesOfDependentsError(
            tempJsonSchema,
            "CoBorrowerDetails"
          )
        }
        props.copySchema(tempJsonSchema, "personalInformation");
      }

      // If any error handling was applied, copy the updated schema to component state
      // if (borrowerNumberOfDependents !== "" && borrowerNumberOfDependents !== undefined ||
      //     coBorrowerNumberOfDependents !== "" && coBorrowerNumberOfDependents !== undefined) {
      // }
    }
  }, [
    // Dependency list: Re-run the effect when any of these values change
    props.componentSchema?.personalInformation,
    props.componentState?.ApplicantDetails?.BorrowerDetails?.NumberOfDependents,
    props.componentState?.ApplicantDetails?.CoBorrowerDetails
      ?.NumberOfDependents,
  ]);

  return (
    <>
      <JsonSchemaForms
        state={state}
        jsonData={jsonSchema}
        changeHandler={changeHandler}
        pageKey={"personalInformation"}
        onLoadFunc={onLoadFunc}
      />
      <EmailMatchDialog
        isOpen={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </>
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PersonalInformation);
